import { ShieldCheck, ShieldAlert, Shield, FileText, CircleDot } from "lucide-react";

const STATUS_STYLES = {
  ACTIVE: "bg-emerald-950/70 text-emerald-400 border-emerald-500/40",
  PROVISIONAL: "bg-amber-950/60 text-amber-400 border-amber-500/40",
  SUBMITTED: "bg-[#140f02]/60 text-[#F0C72A] border-[#E5B31E]/40",
  UNDER_REVIEW: "bg-[#140f02]/60 text-[#F0C72A] border-[#E5B31E]/40",
  PENDING_DOCUMENTS: "bg-[#140f02]/60 text-[#F0C72A] border-[#E5B31E]/40",
  DRAFT: "bg-slate-900/80 text-slate-300 border-slate-700/60",
  SUSPENDED: "bg-rose-950/70 text-rose-400 border-rose-500/50",
  REVOKED: "bg-rose-950/70 text-rose-400 border-rose-500/50",
  REJECTED: "bg-rose-950/70 text-rose-400 border-rose-500/50",
  INACTIVE: "bg-slate-900/80 text-slate-400 border-slate-700/60",
  EXPIRED: "bg-slate-900/80 text-slate-400 border-slate-700/60",
};

export function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.DRAFT;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-mono font-bold uppercase tracking-wider border ${style} ${className}`}
    >
      <CircleDot className="w-3 h-3" />
      {status}
    </span>
  );
}

export function SimBadge({ className = "" }) {
  return (
    <span
      data-testid="sim-badge"
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-mono font-bold uppercase bg-[#140f02]/80 text-[#F0C72A] border border-[#E5B31E]/40 tracking-wider ${className}`}
    >
      SIM
    </span>
  );
}

export function VerifyShield({ state }) {
  if (state === "VALID")
    return <ShieldCheck className="w-full h-full text-emerald-400" />;
  if (state === "SUSPENDED")
    return <ShieldAlert className="w-full h-full text-rose-400" />;
  if (state === "NOT_FOUND")
    return <FileText className="w-full h-full text-slate-500" />;
  return <Shield className="w-full h-full text-slate-400" />;
}

export function GoldPill({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-[#E5B842]/10 text-[#E5B842] border border-[#E5B842]/30 ${className}`}
    >
      {children}
    </span>
  );
}
